import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { css } from "styled-components";

addToListLinkStyles.link = {
    link: {
        css: css`
            font-family: "LatoBold";
            height: 40px;
        `,
    },
};
addToListLinkStyles.wrapper = {
    css: css`
        margin-top: 0;
    `,
};
